import React from 'react';
import { styled } from '@mui/material/styles';
import {
    Box,
    Grid
} from '@mui/material';

const PREFIX = 'Footer';

const classes = {
    root: `${PREFIX}-root`,
    paper: `${PREFIX}-paper`,
    heading: `${PREFIX}-heading`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.root}`]: {
        flexGrow: 1,
    },

    [`& .${classes.paper}`]: {
        padding: theme.spacing(2),
        // textAlign: 'left',
        color: "white",
        backgroundColor: "#333333",//theme.palette.primary.main,
        fontSize: "0.65rem"
    },

    [`& .${classes.heading}`]: {
        fontSize: "2.5rem"
    }
}));

function Footer() {

    let date = new Date()
    let year = date.getFullYear();
    return (
        (<Root>
            <Grid container spacing={0}>
                <Grid item xs={12} sm={12}>
                    <Box className={classes.paper}>
                        <div style={{ textAlign: "left", margin: "0 10% 0 10% " }}>
                            <h3>Terms & Conditions</h3>
                            <p>To use the online billing portal, you agree that you have understood and accepted the following conditions:</p>
                            <p style={{ paddingLeft: "2em" }}>• EnergyAustralia owns the data used to create the invoices and statements. You must only use and reproduce the invoices and statements in accordance with the terms of your electricity contract with EnergyAustralia. </p>
                            <p style={{ paddingLeft: "2em" }}>• Your invoices and statements that you will be able to access contain confidential information. You must only use and disclose that confidential information in accordance with the terms of your electricity contract with EnergyAustralia. </p>
                            <p style={{ paddingLeft: "2em" }}>• You agree to keep your username and password safe from use by third parties. You indemnify EnergyAustralia and its contractors and service providers against any loss or damages which they might suffer, or be liable for, as a result of any unauthorised use of your username and password that may be caused. </p>
                            <p style={{ paddingLeft: "2em" }}>• You can only change your password if you give us 10 business days notice of the change. This is important where an employee who had knowledge of your username and password leaves your employment. </p>
                            <p style={{ paddingLeft: "2em" }}>• EnergyAustralia cannot warrant that your access to the online billing portal will be continuous and fault free. You should report any loss of, or fault in, your access to the online billing portal by contacting us via businessenq@energyaustralia.com.au or by calling 1300 362 466 (Monday to Friday, 9am-5pm AEST).</p>
                            <p style={{ paddingLeft: "2em" }}>• EnergyAustralia has no liability to you arising out of your use of, or reliance on, any information accessed by you via the online billing portal. </p>
                            <p style={{ paddingLeft: "2em" }}>• EnergyAustralia reserves the right to terminate your access to the online billing portal if you breach any of these conditions. </p>
                            <br />
                            <p>&copy; {year} Energy Australia. All rights reserved</p>
                            <p>ABN 99 086 014 968</p>
                            <p>TRUenergy is now operating as EnergyAustralia</p>
                        </div>

                        <br />
                    </Box>
                </Grid>
            </Grid>
        </Root>)
    );
}

export default Footer;
